import { render, staticRenderFns } from "./FinalBreakdownList.vue?vue&type=template&id=6ff5eb77"
import script from "./FinalBreakdownList.vue?vue&type=script&lang=js"
export * from "./FinalBreakdownList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports